module.exports = __webpack_public_path__ + "static/media/bj1.0a90a592.png";